import {
  EMODNET_WMS_HUMAN_ACTIVITIES,
  EMODNET_WMS_GEOLOGY_SUBSTRATE,
  EMODNET_WMS_BATHYMETRY,
  EMODNET_WMS_SEABED_HABITATS
} from "@/config/data-providers.js";
import { EMODNET_WMS_GEOLOGY_BEDROCK } from "./data-providers";

export const LAYER_GROUPS = [
  "EMODnet - Human Activities",
  "EMODnet - Bathymetry",
  "EMODnet - Geology",
  "EMODnet - Seabed Habitats"
];
const PROVIDERS = {
  emodnet: "EMODnet",
  ihthredds: "IHThredds"
};

export const SUITABILITY = {
  provider: PROVIDERS.ihthredds,
  wmsOptions: {
    opacity: 0.8,
    transparent: true,
    format: "image/png",
    colorscalerange: "0,1",
    numcolorbands: 254,
    styles: "boxfill/suitability",
    untiled: true,
    continuousWorld: true,
    zIndex: 1000
  },
  identify: {
    type: "WMS",
    fields: [
      {
        name: "value",
        alias: "Suitability",
        units: "%",
        toUnits: true
      }
    ]
  },
  legendConfig: {
    units: "",
    steps: 100,
    decimals: 0,
    width: 130,
    height: 20,
    position: "bottomleft",
    background: "#f0f0f0b3",
    textColor: "#01212B",
    labels: [0, 50, 100],
    labelFontSize: 9
  }
};

export const FINFISH_FARMS = {
  provider: PROVIDERS.emodnet,
  url: EMODNET_WMS_HUMAN_ACTIVITIES.url,
  group: LAYER_GROUPS[0],
  wmsOptions: {
    layers: "finfish",
    opacity: 1,
    alias: "Aquaculture Finfish Farms",
    transparent: true,
    format: "image/png",
    zIndex: 999
  }
};

export const WMS_LEGEND = {
  format: "image/png",
  transparent: true
};

export const OCEANS_ENERGY = {
  provider: PROVIDERS.emodnet,
  url: EMODNET_WMS_HUMAN_ACTIVITIES.url,
  group: LAYER_GROUPS[0],
  wmsOptions: {
    layers: "oenergy",
    opacity: 1,
    alias: "Ocean Energy Facilities",
    transparent: true,
    format: "image/png",
    zIndex: 998
  },
  showInLayerSwitcher: true
};

export const VESSELS_TRAFFIC = {
  provider: PROVIDERS.emodnet,
  url: EMODNET_WMS_HUMAN_ACTIVITIES.url,
  group: LAYER_GROUPS[0],
  wmsOptions: {
    layers: "2017_01_st_All",
    opacity: 0.8,
    alias: "Vessels Density (2017)",
    transparent: true,
    format: "image/png",
    zIndex: 997
  },
  showInLayerSwitcher: true
};

export const SEABED_SUBSTRATE = {
  provider: PROVIDERS.emodnet,
  url: EMODNET_WMS_GEOLOGY_SUBSTRATE.url,
  group: LAYER_GROUPS[2],
  wmsOptions: {
    layers: "seabed_substrate_1m",
    opacity: 0.8,
    alias: "Seabed Substrates",
    transparent: true,
    format: "image/png",
    zIndex: 996
  },
  showInLayerSwitcher: true
};

export const SEABED_GEOMORPHOLOGY = {
  provider: PROVIDERS.emodnet,
  url: EMODNET_WMS_GEOLOGY_BEDROCK.url,
  group: LAYER_GROUPS[2],
  wmsOptions: {
    layers: "geomorphology",
    opacity: 0.8,
    alias: "Sea-floor Geomorphology",
    transparent: true,
    format: "image/png",
    zIndex: 995
  },
  showInLayerSwitcher: true
};

export const SEABED_BROAD_HABITATS = {
  provider: PROVIDERS.emodnet,
  url: EMODNET_WMS_SEABED_HABITATS.url,
  group: LAYER_GROUPS[3],
  wmsOptions: {
    layers: "eunisMaps_broad",
    opacity: 0.8,
    alias: "EUNIS Broad-scale habitats",
    transparent: true,
    format: "image/png",
    zIndex: 994
  },
  showInLayerSwitcher: true
};

export const SEABED_MEDIUM_HABITATS = {
  provider: PROVIDERS.emodnet,
  url: EMODNET_WMS_SEABED_HABITATS.url,
  group: LAYER_GROUPS[3],
  wmsOptions: {
    layers: "eunisMaps_medium",
    opacity: 0.8,
    alias: "EUNIS Medium-scale habitats",
    transparent: true,
    format: "image/png",
    zIndex: 993
  },
  showInLayerSwitcher: true
};

export const BATHYMETRY = {
  provider: PROVIDERS.emodnet,
  url: EMODNET_WMS_BATHYMETRY.url,
  identify: {
    url: EMODNET_WMS_BATHYMETRY.identifyUrl,
    type: "REST",
    fields: [
      {
        name: "max",
        alias: "Depth Max",
        units: "m"
      },
      {
        name: "min",
        alias: "Depth Min",
        units: "m"
      },
      {
        name: "avg",
        alias: "Depth Average",
        units: "m"
      }
    ]
  },
  group: LAYER_GROUPS[1],
  legendConfig: {
    format: "image/png",
    transparent: true,
    type: "HTTP",
    imageUrl: "http://ows.emodnet-bathymetry.eu/legends/legend_multicolour.png"
  },
  showInLayerSwitcher: true,
  wmsOptions: {
    layers: "mean_rainbowcolour",
    opacity: 0.8,
    alias: "Bathymetry",
    transparent: true,
    format: "image/png",
    zIndex: 992
  }
};
